const { createSelector } = require('reselect')

const selectCampaignList = state => state.setting.campaignList

const getCampaignList = () => createSelector(
  [selectCampaignList],
  cse => cse.data,
)

const getCampaignListError = () => createSelector(
  [selectCampaignList],
  cse => cse.error,
)

const getCampaignListLoading = () => createSelector(
  [selectCampaignList],
  cse => cse.loading,
)

const selectCreate = state => state.setting.createCampaign

const getCreateCampaign = () => createSelector(
  [selectCreate],
  cse => cse.data,
)

const getCreateCampaignError = () => createSelector(
  [selectCreate],
  cse => cse.error,
)

const getCreateCampaignLoading = () => createSelector(
  [selectCreate],
  cse => cse.loading,
)
const selectUpdate = state => state.setting.updateCampaign

const getUpdateCampaign = () => createSelector(
  [selectUpdate],
  cse => cse.data,
)

const getUpdateCampaignError = () => createSelector(
  [selectUpdate],
  cse => cse.error,
)

const getUpdateCampaignLoading = () => createSelector(
  [selectUpdate],
  cse => cse.loading,
)
const selectDelete = state => state.setting.deleteCampaign

const getDeleteCampaign = () => createSelector(
  [selectDelete],
  cse => cse.data,
)

const getDeleteCampaignError = () => createSelector(
  [selectDelete],
  cse => cse.error,
)

const getDeleteCampaignLoading = () => createSelector(
  [selectDelete],
  cse => cse.loading,
)
const selectRouteList = state => state.setting.routeList

const getRouteList = () => createSelector(
  [selectRouteList],
  cse => cse.data,
)

const getRouteListError = () => createSelector(
  [selectRouteList],
  cse => cse.error,
)

const getRouteListLoading = () => createSelector(
  [selectRouteList],
  cse => cse.loading,
)

const selectCreateRoute = state => state.setting.createRoute

const getCreateRoute = () => createSelector(
  [selectCreateRoute],
  cse => cse.data,
)

const getCreateRouteError = () => createSelector(
  [selectCreateRoute],
  cse => cse.error,
)

const getCreateRouteLoading = () => createSelector(
  [selectCreateRoute],
  cse => cse.loading,
)
const selectUpdateRoute = state => state.setting.updateRoute

const getUpdateRoute = () => createSelector(
  [selectUpdateRoute],
  cse => cse.data,
)

const getUpdateRouteError = () => createSelector(
  [selectUpdateRoute],
  cse => cse.error,
)

const getUpdateRouteLoading = () => createSelector(
  [selectUpdateRoute],
  cse => cse.loading,
)
const selectDeleteRoute = state => state.setting.deleteCampaign

const getDeleteRoute = () => createSelector(
  [selectDeleteRoute],
  cse => cse.data,
)

const getDeleteRouteError = () => createSelector(
  [selectDeleteRoute],
  cse => cse.error,
)

const getDeleteRouteLoading = () => createSelector(
  [selectDeleteRoute],
  cse => cse.loading,
)

const selectDoTestAudioCall = state => state.setting.doTestAudioCall

const getDoTestAudioCall = () => createSelector(
  [selectDoTestAudioCall],
  cse => cse.data,
)

const getDoTestAudioCallError = () => createSelector(
  [selectDoTestAudioCall],
  cse => cse.error,
)

const getDoTestAudioCallLoading = () => createSelector(
  [selectDoTestAudioCall],
  cse => cse.loading,
)

const selectPriorityTeamList = state => state.setting.priorityTeamList

const getPriorityTeamList = () => createSelector(
  [selectPriorityTeamList],
  cse => cse.data,
)

const getPriorityTeamListError = () => createSelector(
  [selectPriorityTeamList],
  cse => cse.error,
)

const getPriorityTeamListLoading = () => createSelector(
  [selectPriorityTeamList],
  cse => cse.loading,
)

const selectWebhookList = state => state.setting.webhookList

const getWebhookList = () => createSelector(
  [selectWebhookList],
  cse => cse.data,
)

const getWebhookListError = () => createSelector(
  [selectWebhookList],
  cse => cse.error,
)

const getWebhookListLoading = () => createSelector(
  [selectWebhookList],
  cse => cse.loading,
)

const selectWebhook = state => state.setting.webhook

const getWebhook = () => createSelector(
  [selectWebhook],
  cse => cse.data,
)

const getWebhookError = () => createSelector(
  [selectWebhook],
  cse => cse.error,
)

const getWebhookLoading = () => createSelector(
  [selectWebhook],
  cse => cse.loading,
)

const selectCreateWebhook = state => state.setting.createWebhook

const getCreateWebhook = () => createSelector(
  [selectCreateWebhook],
  cse => cse.data,
)

const getCreateWebhookError = () => createSelector(
  [selectCreateWebhook],
  cse => cse.error,
)

const getCreateWebhookLoading = () => createSelector(
  [selectCreateWebhook],
  cse => cse.loading,
)

const selectDeleteWebhook = state => state.setting.deleteWebhook

const getDeleteWebhook = () => createSelector(
  [selectDeleteWebhook],
  cse => cse.data,
)

const getDeleteWebhookError = () => createSelector(
  [selectDeleteWebhook],
  cse => cse.error,
)

const getDeleteWebhookLoading = () => createSelector(
  [selectDeleteWebhook],
  cse => cse.loading,
)

const selectPriorityTeamDetail = state => state.setting.priorityTeamDetail

const getPriorityTeamDetail = () => createSelector(
  [selectPriorityTeamDetail],
  cse => cse.data,
)

const getPriorityTeamDetailError = () => createSelector(
  [selectPriorityTeamDetail],
  cse => cse.error,
)

const getPriorityTeamDetailLoading = () => createSelector(
  [selectPriorityTeamDetail],
  cse => cse.loading,
)

const selectCreatePriorityTeam = state => state.setting.createPriorityTeam

const getCreatePriorityTeam = () => createSelector(
  [selectCreatePriorityTeam],
  cse => cse.data,
)

const getCreatePriorityTeamError = () => createSelector(
  [selectCreatePriorityTeam],
  cse => cse.error,
)

const getCreatePriorityTeamLoading = () => createSelector(
  [selectCreatePriorityTeam],
  cse => cse.loading,
)

const selectUpdatePriorityTeam = state => state.setting.updatePriorityTeam

const getUpdatePriorityTeam = () => createSelector(
  [selectUpdatePriorityTeam],
  cse => cse.data,
)

const getUpdatePriorityTeamError = () => createSelector(
  [selectUpdatePriorityTeam],
  cse => cse.error,
)

const getUpdatePriorityTeamLoading = () => createSelector(
  [selectUpdatePriorityTeam],
  cse => cse.loading,
)

const selectAddDoctorToPriorityTeam = state => state.setting.addDoctorToPriorityTeam

const getAddDoctorToPriorityTeam = () => createSelector(
  [selectAddDoctorToPriorityTeam],
  cse => cse.data,
)

const getAddDoctorToPriorityTeamError = () => createSelector(
  [selectAddDoctorToPriorityTeam],
  cse => cse.error,
)

const getAddDoctorToPriorityTeamLoading = () => createSelector(
  [selectAddDoctorToPriorityTeam],
  cse => cse.loading,
)

const selectDeletePriorityTeam = state => state.setting.deletePriorityTeam

const getDeletePriorityTeam = () => createSelector(
  [selectDeletePriorityTeam],
  cse => cse.data,
)

const getDeletePriorityTeamError = () => createSelector(
  [selectDeletePriorityTeam],
  cse => cse.error,
)

const getDeletePriorityTeamLoading = () => createSelector(
  [selectDeletePriorityTeam],
  cse => cse.loading,
)

module.exports = {
  getCampaignList,
  getCampaignListLoading,
  getCampaignListError,
  getCreateCampaign,
  getCreateCampaignLoading,
  getCreateCampaignError,
  getUpdateCampaign,
  getUpdateCampaignLoading,
  getUpdateCampaignError,
  getDeleteCampaign,
  getDeleteCampaignLoading,
  getDeleteCampaignError,
  getRouteList,
  getRouteListLoading,
  getRouteListError,
  getCreateRoute,
  getCreateRouteLoading,
  getCreateRouteError,
  getUpdateRoute,
  getUpdateRouteLoading,
  getUpdateRouteError,
  getDeleteRoute,
  getDeleteRouteLoading,
  getDeleteRouteError,
  getDoTestAudioCall,
  getDoTestAudioCallError,
  getDoTestAudioCallLoading,

  getPriorityTeamList,
  getPriorityTeamListError,
  getPriorityTeamListLoading,

  getWebhookList,
  getWebhookListError,
  getWebhookListLoading,

  getWebhook,
  getWebhookError,
  getWebhookLoading,

  getCreateWebhook,
  getCreateWebhookError,
  getCreateWebhookLoading,

  getDeleteWebhook,
  getDeleteWebhookError,
  getDeleteWebhookLoading,

  getPriorityTeamDetail,
  getPriorityTeamDetailError,
  getPriorityTeamDetailLoading,

  getCreatePriorityTeam,
  getCreatePriorityTeamError,
  getCreatePriorityTeamLoading,

  getUpdatePriorityTeam,
  getUpdatePriorityTeamError,
  getUpdatePriorityTeamLoading,

  getAddDoctorToPriorityTeam,
  getAddDoctorToPriorityTeamError,
  getAddDoctorToPriorityTeamLoading,

  getDeletePriorityTeam,
  getDeletePriorityTeamError,
  getDeletePriorityTeamLoading,
}